import { localVariables } from '../../utils/Constant';
import apiClient from '../client';
import { AuthApiService } from '../../Types/Auth';

const ENDPOINT = 'auth';

export const authApi: AuthApiService = {
    login: (payload) => {
        return apiClient.post(`/${ENDPOINT}/login`, payload);
    },
    register: (payload) => {
        return apiClient.post(`/${ENDPOINT}/register`, payload);
    },
    saveAuthData: ({ access_token, access_token_exp, email, roles, type }) => {
        localStorage.setItem(localVariables.ACCESSTOKEN, access_token);
        localStorage.setItem(localVariables.ACCESSTOKEN_EXP, String(access_token_exp));
        localStorage.setItem(localVariables.EMAIL, email);
        localStorage.setItem(localVariables.USER_TYPE, String(type));
        localStorage.setItem(localVariables.ROLES, JSON.stringify(roles));
    },
    clearAuthData: () => {
        localStorage.removeItem(localVariables.ACCESSTOKEN);
        localStorage.removeItem(localVariables.ACCESSTOKEN_EXP);
        localStorage.removeItem(localVariables.EMAIL);
        localStorage.removeItem(localVariables.ROLES);
        localStorage.removeItem(localVariables.USER_TYPE);
    }
};
